import React from "react";

const IconTwitter = ({
  width = "25",
  height = "25",
  fill = "#ffffff",
  className = "",
}) => {
  return (
    <svg
      viewBox="0 0 36 36"
      className={className ? className : null}
      width={width}
      height={height}
      data-name="iconTwitter"
    >
      <rect width="36" height="36" rx="8" fill="black" />
      <path
        d="M20.0951 16.3165L28.2865 7H26.3461L19.2305 15.0878L13.5516 7H7L15.5895 19.2313L7 28.9999H8.9404L16.4497 20.4571L22.4484 28.9999H29M9.64073 8.43174H12.6217L26.3446 27.6385H23.3629"
        fill="white"
      />
      <clipPath id="clip0_3824_1133">
        <rect width="22" height="22" fill="white" transform="translate(7 7)" />
      </clipPath>
    </svg>
  );
};

export default IconTwitter;
